import { useState, useCallback } from 'react';

export interface NotificationState {
  type: 'success' | 'error' | 'info';
  message: string;
  actionText?: string;
  onAction?: () => void;
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState | null>(null);

  const showNotification = useCallback((
    type: 'success' | 'error' | 'info', 
    message: string, 
    actionText?: string,
    onAction?: () => void
  ) => {
    setNotification({ type, message, actionText, onAction });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
}; 